module.exports = __webpack_public_path__ + "static/media/calendarIconBlack.14155713.svg";